import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHUnidadDel = async (credentials, data) => {
    const body = {
        service: "RNHUnidadDel",
        params: {
            rnhUnidadId: data?.id || null,
            rnhUnidadVersion: data?.version ?? null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
